import { render, staticRenderFns } from "./Tnc.vue?vue&type=template&id=73751d20&scoped=true"
import script from "./Tnc.vue?vue&type=script&lang=js"
export * from "./Tnc.vue?vue&type=script&lang=js"
import style0 from "./Tnc.vue?vue&type=style&index=0&id=73751d20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73751d20",
  null
  
)

export default component.exports